var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('LoadingCard'):_c('div',[_c('CreateWeedSprayDiary',{attrs:{"user-id":_vm.userId,"blocks":_vm.availableBlocks}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }